export enum CancelDateCategory {
  RENEWAL = 'renewal',
  TOMORROW = 'tomorrow',
  FUTURE = 'dateInTheFuture',
}

export const DEFAULT_FUTURE_CANCEL_DATE_MAX_NUMBER_OF_DAYS = 30;
